<template>
  <v-dialog v-model="dialog" max-width="476px" persistent>
    <v-card>
      <div class="transport-dialog-wrapper">
        <div class="destinations">
          <div class="departure">
            <span class="label">{{ passage.departure.marker !== null ? passage.departure.marker.label : '' }}.</span>
            <span class="place">{{ passage.departure.name !== null ? passage.departure.name : '' }}</span>
          </div>
          <v-icon >mdi-arrow-right</v-icon>
          <div class="destination">
            <span class="label">{{ passage.destination.marker !== null ? passage.destination.marker.label : '' }}.</span>
            <span class="place">{{ passage.destination.name !== null ? passage.destination.name : '' }}</span>
          </div>
        </div>

        <div class="transports-container">
          <span class="transports-list-title" v-show="!showOptions">{{ staticTranslation('dialogs.selectTransport') }}</span>
          <div class="transports-list" v-show="!showOptions">
            <button 
               class="transport-button" 
               :class="{ active: currentSelection == null || currentSelection == transport }"
               v-for="transport in transports" 
               :key="transport.id"
               @click="selectTransport(transport)">
              <v-icon class="transport-icon">mdi-{{ transport.icon }}</v-icon>
              <span>{{ transport.translations[locale].name }}</span>
            </button>
          </div>
          <transition name="smooth-enter">
            <div class="transport-options" v-if="showOptions">
              <div class="button-container">
                <button @click="cancelOptionSelection">
                  <v-icon>mdi-arrow-left</v-icon>
                  <span>{{ staticTranslation('labels.back') }}</span>
                </button>
              </div>

              <div class="currentSelection">
                <v-icon class="transport-icon">mdi-{{ currentSelection.icon }}</v-icon>
                <span>{{ currentSelection.translations[locale].name }}</span>
              </div>

              <span>{{ staticTranslation('dialogs.selectMotivePower') }}</span>
              <button 
                class="transport-option"
                v-for="option in currentSelection.options" @click="selectOption(option)" :key="option.id">
                <span>{{ option.translations[locale].name }}</span>
              </button>
            </div>
          </transition>
        </div>

        <button class="btn btn-cancel" @click="handleCancel">{{ staticTranslation('dialogs.cancel') }}</button>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import {translationMixins} from '@/mixins/translation-mixins'

export default {
  name: 'TransportDialog',
  mixins: [translationMixins],
  data () {
    return {
      currentSelection: null
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    header: {
      type: String
    },
    transports: {
      type: Array
    },
    departure: {
      type: String
    },
    arrival: {
      type: String
    },
    passage: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      default: 'fi'
    },
  },
  computed: {
    ...mapGetters('translations', {
      translations: 'translations',
    }),
    dialog: {
      /**
       * Getter method for the dialog
       * @return {Boolean} 
       */
      get () {
        return this.value
      },
    
      /**
       * Setter method for the dialog 
       * @param {Boolean} dialog 
       */
      set (dialog) {
        this.$emit('input', dialog)
      } 
    },
    showOptions () {
      return this.currentSelection != null && this.currentSelection.options.length > 0
    }
  },
  methods: {
    staticTranslation(key) {
      return this.getStaticTranslation(this.locale, key, this.translations, this.$t(key))
    },
    selectTransport(transport) {
      if(transport.options.length < 1) {
        this.currentSelection = null
        this.$emit('transport-selected', { transport: transport, option: null })
        return
      }

      this.currentSelection = transport
    },
    selectOption(option) {
      this.$emit('transport-selected', { transport: this.currentSelection, option: option })
      this.currentSelection = null
    },
    handleCancel() {
      this.currentSelection = null
      this.$emit('cancel-dialog')
    },
    cancelOptionSelection() {
      this.currentSelection = null
    },
  }
}
</script>
<style lang="scss" scoped>
.transport-dialog-wrapper {
  z-index: 999;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .transports-container {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .transports-list-title {
      margin-bottom: 10px;
    }

    .transports-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: center;

      .transport-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 10px 10px;
        font-size: 0.75rem;
        transition: all 0.2s linear;
        width: 75px;

        &:focus {
          outline: none;
        }

        .transport-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #ddd;
          color: black;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          margin-bottom: 5px;
        }

        &.active {
          .transport-icon {
            background-color: #E47E67;
            color: white;
          }
        }
      }
    }

    .transport-options {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-height: 90vh;
      font-size: 0.85rem;
      width: 100%;

      .button-container {
        width: 100%;
        display: flex;
      }

      .currentSelection {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .transport-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #ddd;
          color: black;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          margin-bottom: 5px;
          margin-right: 10px;
        }
      }

      .transport-option {
        background-color: #E47E67;
        padding: 3px 20px;
        border-radius: calc(1em + 6px);
        margin-bottom: 10px;
        color: white;

        &:focus {
          outline: none;
        }
      }
    }
  }

  .btn-cancel {
    background-color: #595959;
    color: white;
    padding: 7px 15px;
    font-size: 0.9rem;
    font-weight: bold;
    border-radius: 5px;

    &:focus {
      outline: none;
    }
  }

  .destinations {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 0 20px;
    border-bottom: 1px solid #ddd;

    .departure,
    .destination {
      .label {
        margin-right: 5px;
      }
    }
  }
}

.smooth-enter-active, .smooth-leave-active {
  transition: max-height .5s;
}
.smooth-enter, .smooth-leave-to {
  max-height: 0;
}
</style>
